import { Slide } from "@jelly/lesson";
import theory from "../../theory";
import config from "appConfig";

const principle: Slide = {
  description:
    "Binaural measurement systems can be equalized to produce recordings comparable to those obtained with measurement microphones. This is often done to remain compatible to existing recordings, or to comply with the requirements of measurement and analysis standards. In order to get good compatibility, assumptions about the recording conditions have to be made (e.g. free field or diffuse field conditions).",
  theory: theory,
  layout: {
    type: "table",
    options: {
      cols: 1,
      rows: 2,
      rowsSize: [9, 1],
      components: [
        [
          {
            variant: "layout",
            data: {
              type: "controlsToggleExtraContent",
              options: {
                controlsPosition: "bottom",
                controls: [
                  {
                    type: "button",
                    items: [{ name: "Not equalized" }, { name: "Equalized" }],
                    options: {},
                  },
                ],
                extraContent: [[], []],
                components: [
                  [
                    {
                      variant: "blockContainer",
                      data: {
                        block: {
                          type: "image",
                          options: {
                            src: `${config.ASSETS_URL}/02/16/principle/slide-3-not-equalized.svg`,
                          },
                        },
                        styles: {
                          padding: "5%",
                        },
                      },
                    },
                  ],
                  [
                    {
                      variant: "blockContainer",
                      data: {
                        block: {
                          type: "image",
                          options: {
                            src: `${config.ASSETS_URL}/02/16/principle/slide-3-equalized.svg`,
                          },
                        },
                        styles: {
                          padding: "5%",
                        },
                      },
                    },
                  ],
                ],
              },
            },
          },
        ],
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "hint",
                options: {
                  data: "Free field conditions",
                  color: "default",
                  direction: "row",
                },
              },
            },
          },
        ],
      ],
    },
  },
};

export default principle;
